export const COCO = 'coco';
export const COCO_COOKIES_EXPIRATION = new Date(Date.now() + 1 * 30 * 24 * 60 * 60 * 1e3);
export const ABDCT = 'abdct';
export const VTA = 'vta';
export const HOMEPAGE_PROFILE_TOGGLE = 'homepageProfileToggle';
export const RSU = '_rsu';
export const CHE = '_che';
export const IMANRUT = 'imanrut';
export const OPTANON_CONSENT = 'OptanonConsent';
export const OPTANON_ALERT_BOX_CLOSED = 'OptanonAlertBoxClosed';
